module.exports = __webpack_public_path__ + "images/application/templates/welcome-9a232ef1.png";